<ng-progress #progressBar></ng-progress>
<section class="theme_bg" for="ModifySearch">
    <div class="container" *ngIf="mobileModify">
        <div class="row bg-white py-2 rounded black_bg">
            <div class="col-md-10 col-7">
                <div class="row font-weight-bold">
                    <div *ngIf="tripType == 'Oneway'" class="col-md-4 text-white">One Way Trip</div>
                    <div *ngIf="tripType == 'Roundtrip'" class="col-md-4 text-white">Round Trip</div>
                    <div *ngIf="tripType == 'Multi-city'" class="col-md-4 text-white">Multi City Trip</div>
                    <!-- <div class="col-md-2 text-center"><i class="fa fa-calendar" aria-hidden="true"></i>&nbsp;&nbsp;
                        Departure</div>
                    <div *ngIf="tripType == 'Roundtrip'" class="col-md-2 text-center"><i class="fa fa-calendar"
                            aria-hidden="true"></i>&nbsp;&nbsp;Return</div>
                    <div class="col-md-1 text-center">Adult</div>
                    <div class="col-md-1 text-center">Child</div>
                    <div class="col-md-2 text-center">Infant</div> -->
                </div>
                <div *ngIf="tripType == 'Oneway' || tripType == 'Roundtrip'" class="row">
                    <div class="col-md-12 col-12">
                        {{departureCity}} - {{destinationCity}}
                    </div>
                    <!-- <div class="col-md-2 text-center">{{departureDate | date}} </div>
                    <div *ngIf="tripType == 'Roundtrip'" class="col-md-2 text-center">{{ returnDate | date}}
                    </div>
                    <div class="col-md-1 text-center">{{ traveller?.adults }}</div>
                    <div class="col-md-1 text-center">{{ traveller?.childrens }}</div>
                    <div class="col-md-2 text-center">{{ traveller?.infants }}</div> -->
                </div>
                <div *ngIf="tripType == 'Multi-city'" class="row">
                    <div class="col-md-12 col-12">
                        <div *ngFor="let city of displayCities">
                            {{city.mDepartureCity}}
                        </div>
                    </div>
                    <!-- <div class="col-md-2 text-center">
                        <div *ngFor="let city of displayCities">
                            {{ city.mDepartureDate | date }}
                        </div>
                    </div>
                    <div class="col-md-2 text-center">{{ traveller?.adults }}</div>
                    <div class="col-md-2 text-center">{{ traveller?.childrens }}</div>
                    <div class="col-md-2 text-center">{{ traveller?.infants }}</div> -->
                </div>
            </div>
            <div class="col-md-2 col-5">
                <button type="button" class="btn btn-success btn-lg pull-right btn_hover btn_flight"
                    (click)="isCollapsedSearch = !isCollapsedSearch" [attr.aria-expanded]="!isCollapsedSearch"
                    aria-controls="collapseBasic">
                    Change Flight
                </button>
            </div>
        </div>
    </div>

    <div class="container nopad">
        <div class="row mobile_row bbottom">
            <div class="col-md-12 col-lg-12 p-0">
                <div id="collapseBasic" *ngIf="isCollapsedSearch" style="z-index: 9999; margin-top: 10px;">
                    <div class="">
                        <div class="col-md-12">
                            <!-- <div class="tabs_wrapper">
                                <div class="tabs_section">
                                    <ul class="nav nav-tabs moduletabs" id="myTab" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home"
                                                role="tab" aria-controls="home" aria-selected="true">Flight</a>
                                        </li>
                                    </ul>
                                </div>
                            </div> -->
                            <div class="tab-content searchtabs" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel"
                                    aria-labelledby="home-tab">
                                    <app-flights (callResult)="searchResult($event)"></app-flights>
                                </div>

                                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <!-- <app-hotel></app-hotel> -->
                                </div>
                                <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                    ...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section for="FlightFoundAndListSearchedResult" class="loading-container theme_bg">
    <div class="container">
        <div class="row mobile_row ">
            <div class="col-md-3 col-lg-3 nopad mobile_nopad filter_row" *ngIf="showMobilefilter">
                <div class="flteboxwrp">
                    <div class="fltrboxin rounded-bottom">
                        <div class="celsrch">
                            <div style="padding: 10px 3px 10px 0px">
                                <a (click)="resetFilter()" class="pull-right" style="cursor: pointer;"
                                    id="reset_filters">Reset
                                    All</a>
                             
                                    <a (click)="closeFilter()" class="pull-right closefilter" style="cursor: pointer;">Close</a>
                                    
                            </div>
                            <app-filters></app-filters>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-9 col-lg-9 pl60">
                <div class="row mobile_row" style="margin-top: 5px;">
                    <div class="col-md-12 col-lg-12 pr-0 mobile_nopad">
                        <span class="filterSpan"><b>{{ flights.length }}</b> Flights Found</span>
                        <span class="showMobilefilterbtn" (click)="mobileFilter()"><i class="fal fa-filter"></i></span>
                        <div class="pb-0 mb-2 rounded mob_hide">
                            <div class="card-body pb-0 pt-2 px-0">
                                <app-airline-features></app-airline-features>
                            </div>
                        </div>
                        <div class="card pb-0 mb-2 rounded mob_hide">
                            <div class="card-body py-2" style="padding: 5px 45px !important;">
                                <app-airline-carousel></app-airline-carousel>
                            </div>
                        </div>
                        <app-sorting></app-sorting>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-12 pr-0"></div>
                </div>
                <div *ngIf="flights.length" class="row mobile_row">
                    <div class="col-md-12 col-lg-12 pr-0 mobile_nopad">
                        <div *ngFor="let flight of flights| slice: 0: endSlice; index as i" infiniteScroll
                            [infiniteScrollDistance]="1" [infiniteScrollUpDistance]="2"
                            [infiniteScrollThrottle]="throttle" (scrolled)="onScrollDown(i+1)"
                            class="card flight_list pb-0 mb-4">
                            <div class="arrow-right hide" [ngSwitch]="flight.booking_source">
                                <span *ngSwitchCase='"ZBAPINO00002"' style="font-size: 10px !important;">TP</span>
                                <span *ngSwitchCase='"ZBAPINO00007"' style="font-size: 10px !important;">SB</span>
                                <span *ngSwitchCase='"ZBAPINO00010"' style="font-size: 10px !important;">UB</span>
                                <span *ngSwitchCase='"ZBAPINO00009"' style="font-size: 10px !important;">NV</span>
                                <span *ngSwitchCase='"ZBAPINO00003"' style="font-size: 10px !important;">AM</span>
                            </div>
                            <div class="card-body pt-1 pb-1">
                                <div class="row text-center mobile_row bbottom removeBtm">
                                    <div class="col-md-10 mobile_nopad">
                                        <div *ngFor="let iFlight of flight.FlightDetails.Details;let iindex = index"
                                            class="row  mobile_row addBtm pt-1 pb-1">
                                            <div class="col-md-2 mobile_nopad">
                                                <div class="d-flex flex-column malign">
                                                    <div class="mobile_left">
                                                        <img class="rounded mob_hide"
                                                            style="padding-top: 5px; width:90px; height: 50px;"
                                                            [src]="[airline_logo + iFlight[0].OperatorCode + '.svg']"
                                                            alt="">
                                                    </div>
                                                    <div class="deemFont mobile_left">
                                                        <img width="40" class="rounded mob_show"
                                                            style="padding-top: 5px;"
                                                            [src]="[airline_logo + iFlight[0].OperatorCode + '.svg']"
                                                            alt="">
                                                        {{ iFlight[0].OperatorName}}
                                                        <p>
                                                            <ng-container
                                                                *ngFor="let flight of iFlight; let i = index;last as isLast">
                                                                {{flight.OperatorCode + ' ' + flight.FlightNumber}}
                                                                <span *ngIf="!isLast"><strong>|</strong></span>
                                                            </ng-container>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-4 px-0 text-right mobile_left">
                                                <div class="d-flex flex-column">
                                                    <div class="timesFont">
                                                        {{ iFlight[0].Origin.DateTime | date: 'HH:mm' }}
                                                    </div>
                                                    <div class="">
                                                        {{ iFlight[0].Origin.DateTime | date:'EE, d MMM y'}}
                                                    </div>
                                                    
                                                    <div style="color: #082b3a;
                                                    font-weight: bold;">
                                                        {{ iFlight[0].Origin.CityName +' ('+
                                                        iFlight[0].Origin.AirportCode + ')' }}
                                                    </div>
                                                    <div *ngIf="iFlight[0].Origin.Terminal" class="text-alternate hide_ter">
                                                        Terminal - {{ iFlight[0].Origin.Terminal }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-4 px-1">
                                                <div class="width_auto">
                                                    <div class="text-info" style="margin-bottom: 10px;">
                                                        {{iFlight.length-1}} stop
                                                        <div class="deemFont">
                                                            <strong class="mob_hide">Trip duration : </strong>
                                                            <span *ngIf="flight.Attr?.DurationList">{{flight.Attr?.DurationList[iindex]}}</span>
                                                            <span *ngIf="!(flight.Attr?.DurationList)">{{iFlight[0].Duration}}</span> 
                                                        </div>
                                                        
                                                    </div>
                                                    <!-- timeline section -->
                                                    <div class="container">
                                                        <div class="route"></div>
                                                        <div class="stopsWrapper">
                                                            <div class="stop" *ngFor="let s of Fstops"
                                                                (click)="onStopSelection(s)"></div>
                                                        </div>
                                                    </div>
                                                    <!-- timeline section -->
                                                    <div class="layovertime2">
                                                        Layover Time: {{iFlight[0].Duration}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-4 px-0 text-left mobile_right">
                                                <div class="d-flex flex-column">
                                                    <div class="timesFont">
                                                        <span>
                                                            {{ iFlight[stops(iFlight)].Destination.DateTime |
                                                            date: 'HH:mm'}}
                                                            <sup *ngIf="iFlight | map: checkDays"
                                                                style="vertical-align: super; top: -1px;"
                                                                class="text-danger font-italic font-weight-bold">
                                                                +{{ iFlight | map: checkDays }} day </sup>
                                                        </span>
                                                    </div>
                                                    <div class="">
                                                        {{ iFlight[stops(iFlight)].Destination.DateTime | date:'EE, d
                                                        MMM y'}}
                                                    </div>
                                                    
                                                    <div style="color: #082b3a;
                                                    font-weight: bold;">
                                                        {{ iFlight[stops(iFlight)].Destination.CityName + ' (' +
                                                        iFlight[stops(iFlight)].Destination.AirportCode + ')' }}
                                                    </div>
                                                    <div *ngIf="iFlight[stops(iFlight)].Destination.Terminal"
                                                        class="text-alternate hide_ter">
                                                        Terminal - {{ iFlight[stops(iFlight)].Destination.Terminal }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 mobile_bornone mobile_nopad bord_left">
                                        <div class="d-flex flex-column addLeftBorder mobile_flex">
                                            <div class="mt-2">
                                                <span *ngIf="displaySeats(flight)" style="font-size: 16px;">
                                                    {{ flight.FlightDetails.Details[0][0].Attr.AvailableSeats }}
                                                    Seats
                                                </span>
                                                <br />
                                                <span style="font-size: 16px;" *ngIf="flight.Attr.IsRefundable == 1">
                                                    <strong>Non Refundable</strong>
                                                </span>
                                                <span class="text-success" *ngIf="flight.Attr.IsRefundable == 0">
                                                    <strong>Refundable</strong>
                                                </span>
                                                <br />
                                                <ng-template #popTemplate>
                                                    <app-booking-fare-summary [flight]="flight" [showFlightDetails]="false">
                                                    </app-booking-fare-summary>
                                                </ng-template>
                                                <span [ngbTooltip]="popTemplate" placement="left"
                                                    class="tooltip-300 amnFont row">
                                                    <i style="color: #e3a32e;" class="fas fa-info-circle"></i> {{
                                                    flight.Price.Currency}}
                                                    {{ (flight.Price.TotalDisplayFare) | number:'1.1-2' }}
                                                </span>
                                            </div>
                                            <div class="">
                                                <button (click)="onBookNow(flight)" class="btn w-100 srch_btn">
                                                    {{'Book Now'}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <app-flight-details [flight]="flight"></app-flight-details>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!flights.length" class="row">
                    <div class="col-md-12 col-lg-12 pr-0 no_flight_section">
                        <div class="card-body pb-0">
                            <img class="no_flight_found" src="assets/images/no_flight_found.jpg" alt="" />
                            <p>No Flights Found!!!</p> 
                            <p *ngIf="serverError">There is a technical issue. Please try after sometime</p>
                            <p *ngIf="!serverError && searchingFlight">Searching best flights...</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ngx-loading [show]="loading"
            [config]="{primaryColour: primaryColour, secondaryColour: secondaryColour, tertiaryColour: primaryColour, backdropBorderRadius: '3px',fullScreenBackdrop:true}"
            [template]="loadingTemplate"></ngx-loading>
</section>